module.exports = require("remark-stringify");


//////////////////
// WEBPACK FOOTER
// external "remark-stringify"
// module id = 61
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13